import"../validator";const y=(...n)=>(a,o,t)=>n.forEach(i=>i(a,o,t));export{y as and};
